import React from "react";
import {useHistory} from "react-router-dom";

//helpers:
import {parseSliderParams} from "../Util/ComponentHelper";
import {useTranslation} from "react-i18next";

//components:
import CustomSlider from "../Partials/CustomSlider";
import {SwiperSlide} from "swiper/react";
import SimpleVideoSlide from "../Partials/Slides/SimpleVideoSlide";
import SlideTaller from "../Partials/Slides/SlideTaller";

const ComputedComponent = ({component}) => {
    const history = useHistory();
    const {name = "", parameters = [], data = []} = component;
    const {t} = useTranslation();

    let isTrackList = parameters?.find(param => param.key === "function")?.value === "getTrackList";

    const getComponentName = () => {
        const nameToLowerCase = name?.toLowerCase();
        if (nameToLowerCase) {
            if (nameToLowerCase === "recommended for you") {
                return t("HOME.COMPONENTS.NAME.RECOMMENDED");
            } else if (nameToLowerCase === "all tracks") {
                return t("HOME.COMPONENTS.NAME.ALLTRACKS");
            } else if (nameToLowerCase === "latest videos") {
                return t("HOME.COMPONENTS.NAME.LATEST");
            }
            return name;
        }
    };

    return (
        <div className={`d-flex flex-column container ${isTrackList ? "mb-8" : ""}`}>
            <div className="d-flex justify-content-between mt-4">
                <h3 className="mb-3 home_carousels_title">{getComponentName()}</h3>
            </div>
            <div className={"custom-slide"}>
                {data?.length !== 0 ? (
                    <CustomSlider>
                        {data.map((item, i) => {
                            let {background, title, textLeft, textRight, callbackUrl, type_id} = parseSliderParams(
                                item
                            );
                            return (
                                <SwiperSlide key={i} className="movieShowcase__container--movie__netflix">
                                    {isTrackList ? (
                                        <SlideTaller
                                            background={background}
                                            title={item.visibleTitle ? title : null}
                                            callback={() => history.push(callbackUrl)}
                                        />
                                    ) : (
                                        <SimpleVideoSlide
                                            background={background}
                                            title={title}
                                            textLeft={textLeft}
                                            textRight={textRight}
                                            callback={() => history.push(callbackUrl)}
                                            type_id={type_id}
                                        />
                                    )}
                                </SwiperSlide>
                            );
                        })}
                    </CustomSlider>
                ) : null}
            </div>
        </div>
    );
};
export default ComputedComponent;
